import React from 'react';
import clsx from 'clsx';

import './index.scss';
import logoRecruit from 'assets/logo-hd.png';
import PcTitle from 'components/molecules/PcTitle';
import PcProgress from 'components/molecules/PcProgress';

const PcHeader = ({
  title,
  state,
  path,
}) => {
  const isThanksPage = path.includes('thanks') ? true : false;
  return (
    <div className='PcHeader'>
      <div className="pc-header">
        <div className="pc-header-wrapper">
          <div className="pc-header-area">
            <div className="logo-area">
              <a href="/sol/contents/client/" target="_blank" rel="noopener noreferrer">
                <img className="" src={logoRecruit} alt="logo-recruit" />
              </a>
            </div>
            <div className="map-area">
              <ul className="url-area">
                <li><a href="/cl/service" target="_blank" className="menu">サービス</a></li>
                <li><a href="/cl/branch" target="_blank" className="menu">拠点</a></li>
                <li><a href="/cl/column" target="_blank" className="menu">コラム</a></li>
                <li><a href="/cl/seminar" target="_blank" className="menu">セミナー</a></li>
              </ul>
            </div>
            <div className="side-btn-area">
              <a href="/sol/op53/sd37/" target="_blank" className="side-btn">
                <button className="" type="button">
                  お問い合わせ
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="pc-header-horizon" />
      <div className={clsx('pc-progress', { mB30: isThanksPage })}>
        <PcProgress path={path} />
      </div>
      <div className="pc-title">
        <PcTitle
          title={title}
          state={state}
          path={path}
        />
      </div>
    </div>
  );
};

export default PcHeader;
